<template>
  <div class="about-us">
    <Wrapper class="container-fluid">
      <div
        class="container-fluid_wrapper"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-once="true"
      >
        <div class="container-fluid_wrapper_child">
          <div class="content" style="">
            <div class="sec">
              <h2 class="heading">About Us</h2>
              <p>
                Travvir (short for ‘Travel Virtually’) is an AI Image research
                and development company.
                <br />
                <br />
                Our advanced machine learning models transform real-world
                environments into immersive digital replicas using data captured
                directly from smartphones, making it easy and engaging for
                anyone to create and explore places digitally.
                <br />
                <br />
                We started our journey in August 2019 with the objective of
                building technology that helps us explore places in detail.
                Based in India, Travvir is expanding globally, revolutionizing
                how places are digitally captured and experienced.
              </p>
            </div>
            <div class="sec">
              <h2 class="heading">What makes our tech special</h2>
              <ol type="1">
                <li>
                  <p class="desc">
                    <span class="bold"
                      >1. Content creation is democratized-
                    </span>
                    Our technology eliminates the need for specialized hardware
                    cameras. This breakthrough allows us to create digital
                    replicas of places across the globe at scale.
                  </p>
                </li>
                <li>
                  <p class="desc">
                    <span class="bold">2. Seamless Exploration- </span>
                    Our AI Assistant Mira acts as a sales executive who is
                    active 24*7 & helps people explore places seamlessly.
                  </p>
                </li>
              </ol>
            </div>
          </div>
        </div>
        <div class="container-fluid_wrapper_child1">
          <div
            class="img-wrapper"
            :style="{ backgroundImage: `url(${baseUrl}/bg/bg-2.jpg)` }"
          >
            <img :src="`${imageUrl}/videos/wave.gif`" alt="showcase" />
          </div>
        </div>
      </div>
    </Wrapper>
    <Wrapper class="container space-y">
      <div class="sec">
        <h2 class="heading center">Our Leadership Team</h2>
      </div>
      <div class="container-wrapper">
        <div class="row" :style="{ margin: 0 }">
          <div v-for="member in core" :key="member.name">
            <div class="team text-center">
              <div class="position-relative">
                <img
                  :src="`${imageUrl}/${member.url}/${member.img}`"
                  class="img-fluid avatar avatar-ex-large rounded-pill shadow"
                  alt="memeber logo"
                  loading="lazy"
                />
                <ul class="list-unstyled social-icon team-icon mb-0 mt-4">
                  <li class="list-inline-item">
                    <NuxtLink
                      target="_blank"
                      :to="member.linkedin"
                      class="rounded"
                      ><RiLinkedinBoxFill size="1.1em"
                    /></NuxtLink>
                  </li>
                </ul>
              </div>
              <div class="content pt-3 pb-3">
                <h5 class="mb-0">
                  <NuxtLink
                    target="_blank"
                    :to="member.linkedin"
                    class="name text-dark"
                    >{{ member.name }}</NuxtLink
                  >
                </h5>
                <small class="designation text-muted">{{ member.role }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  </div>
</template>

<script setup>
import Aos from "aos";
import { RiLinkedinBoxFill } from "@remixicon/vue";
const config = useRuntimeConfig();

//seo meta tags

useSeoMeta({
  title: "About Us | Kubma",
  description:
    "Travvir is an AI Image research and development company. Our advanced machine learning models transform real-world environments into immersive digital replicas using data captured directly from smartphones.",
  image: config.public.NUXT_CDN_URL + "/static/website/bg/bg-2.jpg",
  keywords:
    "AI Image research, digital replicas, machine learning models 360 view, virtual tour, 3D tour, 360 rendering",
  ogTitle: "About Our Company",
  ogDescription: "Discover our story and what makes us unique",
  // ogImage: "",
  ogUrl: "https://travvir.com/about",
  twitterCard: "summary_large_image",
  twitterTitle: "About Our Company",
  twitterDescription: "Learn about our company story",
  // twitterImage: "/images/about-us.jpg",
});

//variable
const baseUrl = config.public.NUXT_CDN_URL + "/static/website";
const imageUrl = config.public.NUXT_CDN_URL + "/static";
const team = ref([
  {
    name: "Rohan Mital",
    role: "CEO",
    linkedin: "https://www.linkedin.com/in/rohan-mital-7a05b8145/",
    img: "rohan2.jpg",
    url: "website",
  },
  {
    name: "Rupesh Pandey",
    role: "CTO",
    linkedin: "https://www.linkedin.com/in/rupesh-pandey-424b8754/",
    img: "rupesh.png",
    url: "website",
  },
  // {
  //   name: 'Ashutosh Tripathi',
  //   role: 'Lead Developer',
  //   linkedin: 'https://www.linkedin.com/in/ashutosh-tripathi-b73884bb/',
  //   img: 'ashu.png',
  //   url: 'website'
  // },
  {
    name: "Priyam Harsh",
    role: "Lead Developer",
    linkedin: "https://www.linkedin.com/in/priyamharsh14/",
    img: "priyam.jpg",
    url: "website",
  },
  {
    name: "Sumanyu Asthana",
    role: "ML Head",
    linkedin: "https://www.linkedin.com/in/sumanyu-asthana/",
    img: "sumanyu2.jpg",
    url: "website",
  },
  // {
  //   name: 'Lalit Arora',
  //   role: 'Head of Finance',
  //   linkedin: 'https://www.linkedin.com/in/lalit-arora-2019361a4/',
  //   img: 'lalit.jpg',
  //   url: 'images'
  // },
  // {
  //   name: 'Ashish Semwal',
  //   role: 'Head of Sales',
  //   linkedin: 'https://www.linkedin.com/in/ashish-semwal-a6552513/',
  //   img: 'ashish2.jpg',
  //   url: 'images'
  // },
  // {
  //   name: 'Gourav Kumar',
  //   role: 'Frontend Developer',
  //   linkedin: 'https://www.linkedin.com/in/gourav-kumar-19111b279/',
  //   img: 'gourav.jpg',
  //   url: 'images'
  // },
  // {
  //   name: 'Chandan Pandey',
  //   role: 'Backend Developer',
  //   linkedin: 'https://www.linkedin.com/in/chandan-pandey-20b950276/',
  //   img: 'chandan.jpg',
  //   url: 'images'
  // },
  {
    name: "Sanjiv Mital",
    role: "Board Member",
    linkedin: "https://www.linkedin.com/in/sanjiv-mital-650214/",
    img: "sanjiv.jpg",
    url: "website",
  },
  {
    name: "Arvind Jha",
    role: "Advisor",
    linkedin: "https://www.linkedin.com/in/arvind-jha-6a3512/",
    img: "arvind.jpg",
    url: "website",
  },
  {
    name: "Ranjit Singh",
    role: "Board Member",
    linkedin: "https://www.linkedin.com/in/ranjit-singh-67016470/",
    img: "ranjit.jpg",
    url: "website",
  },
  {
    name: "Yash Gupta",
    role: "Mentor",
    linkedin: "https://www.linkedin.com/in/yash-gupta-ygrellp/",
    img: "yashgupta.jpg",
    url: "images",
  },
]);

//computed
const core = computed(() => {
  const core = team.value;
  return core.sort();
});

//mouted
onMounted(() => {
  Aos.init();
});
</script>
<style lang="scss" scoped>
.about-us {
  $t_c: white;
  background-color: #000;
  font-family: "Manrope";
  padding: 2em;
  padding-top: 6em;
  font-size: 16px;
  @include respond-below(sm) {
    overflow: hidden;
    font-size: 12px;
    padding: 0;
    padding-top: 4em;
  }
  .container-fluid {
    max-width: 1400px;
    &_wrapper {
      display: flex;
      @include respond-below(sm) {
        flex-direction: column-reverse;
      }
      width: 100%;
      &_child {
        width: calc(50vw - 50px);
        @include respond-below(sm) {
          width: 100%;
        }
      }
      &_Child1 {
        width: 45vw;
        @include respond-below(sm) {
          width: 100%;
        }
      }
    }
  }
  h1 {
    font-size: 2.6em;
    color: $t_c;
  }
  h2.heading {
    font-style: normal;
    font-weight: 700;
    font-size: 39px;
    line-height: 2;
    letter-spacing: 0px;
    color: #fff;
    font-family: Manrope, sans-serif;
    @include respond-below(sm) {
      font-size: 26px;
    }
    &.center {
      text-align: center;
    }
  }
  p {
    font-family: Manrope, sans-serif;
    font-weight: 400;
    font-size: 18.25px;
    color: #fff;
    line-height: 1.2152;
    letter-spacing: 0.152px;
    @include respond-below(sm) {
      font-size: 16px;
    }
    &.bold {
      font-weight: 700;
    }
    &.desc {
      width: 96%;
      margin-top: unset;
      /* margin-left: 1.1em; */
    }
  }
  .container-wrapper {
    width: 100%;
    max-width: 78.75rem;
  }
  .row {
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(4, 1fr);
    @include respond-below(lg) {
      grid-template-columns: repeat(3, 1fr);
    }
    @include respond-below(md) {
      grid-template-columns: repeat(2, 1fr);
    }
    @include respond-below(sm) {
      margin-top: 2rem;
      grid-template-columns: repeat(1, 1fr);
    }
    margin-top: 2em;
    @include respond-below(sm) {
      margin-top: 0;
    }
  }
  .img-wrapper {
    display: flex;
    justify-content: center;
    top: 2em;
    background-position: 20% 40%;
    background-size: cover;
    img {
      max-height: min(85vh, 800px);
      @include respond-below(sm) {
        max-height: 290px;
      }
    }
  }
  .sec {
    &:not(:first-child) {
      margin-top: 1em;
    }
    ol {
      margin: 0;
      padding-left: 0.5em;

      /* list-style: none; */
      li {
        margin-top: 2em;
        &:first-child {
          margin-top: 0.5rem;
        }
        &::marker {
          font-weight: 700;
          font-size: 16px;
        }
      }
    }
  }
  .space-y {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-block: 2em;
  }
  .content {
  }
  .team {
    text-align: center;
    margin-top: 4em;
    img {
      transition: all 0.5s ease;
      vertical-align: middle;
      border-style: none;
    }
    &:hover img {
      -webkit-box-shadow: 0 0 3px rgb(60 72 88 / 15%);
      box-shadow: 0 0 3px rgb(60 72 88 / 15%);
      opacity: 0.2;
    }
    &:hover .team-icon {
      opacity: 1;
    }
    .avatar.avatar-ex-large {
      height: 180px;
      width: 180px;
    }
    .shadow {
      -webkit-box-shadow: 0 0 3px rgb(60, 72, 88, 15%) !important;
      box-shadow: 0 0 3px rgb(60, 72, 88, 15%) !important;
    }
    .rounded-pill {
      border-radius: 50rem !important;
    }
    .team-icon {
      position: absolute;
      bottom: 50%;
      -webkit-transform: translateY(50%);
      transform: translateY(50%);
      right: 0;
      opacity: 0;
      left: 0;
      text-align: center;
      -webkit-transition: all 0.5s ease;
      transition: all 0.5s ease;
      .list-inline-item {
        display: inline-block;
        font-size: 2em;
      }
      .social-icon li a {
        border: 1px solid $t_c;
        display: inline-block;
        height: 32px;
        text-align: center;
        font-size: 15px;
        width: 32px;
        line-height: 30px;
        -webkit-transition: all 0.4s ease;
        transition: all 0.4s ease;
        overflow: hidden;
        position: relative;
      }
      .rounded {
        border-radius: 10px !important;
        color: $t_c;
        // background-color: #dadada;
      }
    }
    .text-dark {
      color: hsla(0, 0%, 100%, 0.9) !important;
    }
    a {
      text-decoration: none !important;
    }
    .text-muted {
      color: #8492a6 !important;
    }
    .text-center {
      text-align: center !important;
    }
    .position-relative {
      position: relative;
    }
    .content {
      margin-top: 1em;
      font-size: 16px;
    }
  }
}
</style>
